import { CartButton } from "@components/cartbutton/v3";
import { Star } from "@components/star";
import { TProduct } from "@components/types";
import { getFirst, getImageObject, getSafeUrl, humanizeCurrency, sanityIoImageLoader } from '@core/utils';
import Image from "next/image";
import Link from "next/link";
import React from "react";

type Props = {
    product: TProduct;
};


export const TrendingProductCard: React.FC<Props> = ({ product }) => {

    return (
        <div className="flex flex-col bg-neutral-50 rounded-lg border border-solid border-neutral-300 overflow-hidden w-full">
            {product.tag &&
                <div className="absolute top-3 right-0 z-10 w-max rounded-l-md font-medium text-neutral-700 bg-brand-500 py-0.5 px-2 select-none">
                    {product.tag}
                </div>
            }
            <div className="flex flex-row">
                <Link href={`/product/${product.id}/${getSafeUrl(product.name)}`} prefetch={false}>
                    <div className="relative flex justify-center w-40 h-40">
                            <Image
                                loader={sanityIoImageLoader}
                                src={getImageObject(product.images)?.url}
                                alt={getImageObject(product.images)?.description || product.name || ''}
                                width="200"
                                height="200"
                                className="w-40 h-full object-contain scale-100 hover:scale-105 focus:scale-105 ease-in duration-200"
                            />
                    </div>
                </Link>
                <div className="p-2 leading-tight w-full flex flex-col justify-between overflow-hidden">
                    <div>
                        <p className="font-medium line-clamp-2 md:text-base text-sm text-neutral-900">{product.name}</p>
                    </div>
                    <div>
                    <div className="flex flex-row gap-2">
                        {
                            product?.stats != null && product?.stats != undefined ?
                                <div className="py-2">
                                    <div className="pb-1">
                                        <Star rating={product?.stats?.rating_overall} />
                                    </div>
                                </div>
                                :
                                <div className="py-2">
                                    <span className="text-sm text-error-300 font-manrope font-medium">No Ratings</span>
                                </div>
                        }
                    </div>
                    <div className=" flex flex-col gap-2 justify-between py-0.5">
                        <div className="text-neutral-700 font-bold text-custom_black text-lg">
                            <span>{humanizeCurrency(product.mrp)}</span>
                        </div>
                        {product?.inventories?.length != 0 ?
                            <div className="flex flex-row gap-4 pt-1 w-full">
                                <CartButton product={product} inventory={getFirst(product?.inventories)} mode={"trending"}></CartButton>
                            </div>
                            :
                            <></>
                        }
                    </div>
                    </div>
                </div>
            </div>
        </div >
    )
}